import { useState } from "react";
import { FaInfo } from "react-icons/fa6";

import classes from "./InfoButton.module.css";

const InfoButton = ({ block, item }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={classes.BlockInfoBtn} onClick={() => block ? setIsOpen(!isOpen) : item ? Vues.show(item.vue) : null}>
      <FaInfo />
      {
        isOpen && <div className={classes.BlockInfo}>
          <h1>{block.title}</h1>
          <p>{block.description}</p>
        </div>
      }
    </div>
  );
};

export default InfoButton;